import { group } from 'd3';
import { useMemo } from 'react';
import { element, useElementProps } from '../../../core/elements';
import { scaleLinear, scaleOrdinal } from '../../../primitives/scale';
import { Theme } from '../../../primitives/theme';
import { BarScalesElement, calculateXScaleDomain, calculateYDomain, useMaximumYValue } from '../../bar/elements/scale';

/** Public props */

function BarStackHorizontalScalesElement(props) {
  const {
    data,
    x,
    y,
    color,
    width,
    height,
    yDomain,
    timeUnit,
    normalize,
    children
  } = useElementProps(BarScalesElement, {
    mergeWith: props
  });
  const {
    fillStyles,
    enableDefaultPatterns,
    useThemeFillStyles
  } = useElementProps(Theme);
  const totalYValue = useMaximumYValue(data || [], x, y, true);
  const value = useMemo(() => {
    const xScaleRange = [height, 0];
    const xScalePadding = 0.25;
    const xScale = calculateXScaleDomain({
      xData: data.map(x),
      timeUnit,
      range: xScaleRange,
      padding: xScalePadding
    });
    const yScale = scaleLinear({
      domain: calculateYDomain({
        totalYValue,
        yDomain,
        normalize
      }),
      range: [0, width]
    });
    const {
      domain,
      range
    } = useThemeFillStyles({
      fillStyles,
      enableDefaultPatterns
    });
    const colorScale = scaleOrdinal({
      domain: domain ? domain : data.map(color),
      range: range
    });
    const seriesData = group(data, x);
    return {
      xScale: yScale,
      yScale: xScale,
      colorScale,
      seriesData
    };
  }, [data, width, height, totalYValue, x, yDomain, timeUnit, fillStyles, enableDefaultPatterns]);
  return children(value);
}
const _BarStackHorizontalScalesElement = element(BarStackHorizontalScalesElement, {
  as: BarScalesElement
});
export { _BarStackHorizontalScalesElement as BarStackHorizontalScalesElement };